function generateTOC(str) {
    const regex = /(<p>\+\+toc( \+\+remove-line-start-steps)?<\/p>)/g;

    let m;
    let finalHTML = str;

    while ((m = regex.exec(str)) !== null) {
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        if (m[1]) {
            const titles = extractTitles(str);
            const removeSteps = m[2];
            const list = createList(titles, removeSteps);
            finalHTML = finalHTML.replace(m[0], list);
        }
    }

    finalHTML = finalHTML.replace(
        /<h([1-9]) id="([a-z-0-9]+)"><a href="#\2".+><svg.+svg><\/a>(.+)<\/h\1>/g,
        (all, title, id, label) => {
            return `<h${title} id="${id}">${label} <a class="header-anchor" aria-hidden="true" href="#${id}"><i class="zmdi zmdi-link"></i></a></h${title}>`;
        },
    );

    return finalHTML;
}

function extractTitles(str) {
    const regex = /<h2 id="([a-z-0-9]+)"><a.+<\/a>(.+)<\/h2>/g;

    let m;
    const titles = [];
    while ((m = regex.exec(str)) !== null) {
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        titles.push({
            id: m[1],
            text: m[2],
        });
    }

    return titles;
}

function createList(titles, removeSteps) {
    const items = titles.map(title => {
        return createItem(title, removeSteps);
    });
    return `<ol class="toc">${items.join("")}</ol>`;
}

function cleanSteps(str) {
    return str.replace(/Step [a-z0-9]+: /g, "");
}

function createItem(item, removeSteps) {
    const text = removeSteps ? cleanSteps(item.text) : item.text;
    return `<li><a href="#${item.id}">${text}</a></li>`;
}

export default generateTOC;



// WEBPACK FOOTER //
// ./src/utils/generateTOC.js